import { Request } from '../main'
import  Image  from 'next/image'
import { FaFacebookF, FaInstagram, FaYoutube, FaTwitter, FaShoppingCart, FaUsers, FaCompressArrowsAlt } from 'react-icons/fa'
import Link from 'next/link'
import { isDomain } from '../utils/general'
const request = new Request(process.env.apiDomain)

const SocialLinks = props => (
    <span className="rounded-circle text-center d-flex align-items-center justify-content-center guidesocialMedia mr-2">
        <Link href={props.link}><a className="text-white d-flex">{props.icon}</a></Link>
    </span>
)

function YourGuide(props) {
    const site = props.site.site
    const { data: hub } = request.website.swrSite(site.accountId, "HUB")
    const { data: profile } = request.account.swrAccountProfile(site.accountId)
    const { data: social } = request.account.swrSocialMedia(site.accountId, profile ? profile.user.id : profile)
    const { data: branding } = request.account.swrBranding(site.accountId, profile ? profile.user.id : profile)
    const { data: shaklee } = request.account.swrShakleeInfo(site.accountId, profile ? profile.user.id : profile);

    const config = hub && hub.config ? JSON.parse(hub.config) : '';
    const is_forwarding = config ? config.is_forwarding : 0;
    const hubSubdomainUrl = hub ? hub.subdomainUrl : '';

    const hubUrl = hub ? (isDomain(hub.url) && is_forwarding == 0 ? 'www.'+hub.url : hubSubdomainUrl) : '';


    const groupRetention = social && social.facebook_group_retention ? 'https://www.facebook.com/groups/'+social.facebook_group_retention : '';
    const groupDiscovery = social && social.facebook_group_discovery ? 'https://www.facebook.com/groups/'+social.facebook_group_discovery : '';

    const groupUrl = groupRetention ? groupRetention : groupDiscovery;

    return (
        <div className="yourguide">
            { profile ? 
            <>
                <Image width={170} height={170} src={profile.avatar ? profile.avatar : '/images/profile-default.jpg'} className="img-fluid rounded-circle"/>
                { branding && branding.branding_handle ? <p className="mb-0">{ branding.branding_handle }</p> : null }
                <p className="mb-0">{ profile.name }</p>
                <p>{ profile.phone ? profile.phone : null }</p>
            </>
            : null }
            <div className="mb-5">
                <p className="mb-0">Follow me</p>
                { social ?
                <div className="d-flex mb-2">
                    { social.facebook ? <SocialLinks link={ "https://www.facebook.com/" + social.facebook } icon={<FaFacebookF/>}/> : null }
                    { social.instagram ? <SocialLinks link={ "https://www.instagram.com/" + social.instagram } icon={<FaInstagram/>}/> : null }
                    { social.youtube ? <SocialLinks link={ "https://www.youtube.com/" + social.youtube } icon={<FaYoutube/>}/> : null }
                    { social.twitter ? <SocialLinks link={ "https://www.twitter.com/" + social.twitter } icon={<FaTwitter/>}/> : null }
                </div>
                : null }
                { shaklee && shaklee.shaklee_pws_name ? <Link href={"https://pws.shaklee.com/" + shaklee.shaklee_pws_name }><a className="mr-3 h5 text-reset"><Image width={35} height={35} src="/images/sections/img-visit-my-wellness-shop-01.svg"/></a></Link> : null }
                { hub ? <a href={"//" + hubUrl} className="mr-3 h5 text-reset"><Image width={30} height={30} src="/images/sections/img-visit-my-hubsite.svg"/></a> : null }
                { groupUrl ? <Link href={groupUrl}><a className="ml-1 mr-3 h5 text-reset"><Image width={35} height={35} src="/images/sections/img-join-the-community01.svg"/></a></Link> : ''} { /* Would use JoinCommunity block but icon too big */ }
                <p>{ hub ? <a href={'//' + hubUrl + "/about"} className="mr-3 h7">Have you read my story?</a> : null }</p>

            </div>
            <style jsx global>
                {`
                    
                    .guidesocialMedia{
                        width:30px;
                        height:30px;
                        padding:4px;
                    }
                    @media(max-width:991px){
                        .yourguide{
                            font-size:.9rem;
                        }
                    }
                `}
                
            </style>
        </div>
    )
}

export default YourGuide
